import { AppBar, Toolbar, Container, Box, Button, IconButton, Typography } from '@mui/material'
import LanguageIcon from '@mui/icons-material/Language'
import { useLanguage } from '../../contexts/LanguageContext'
import { useNavigate } from 'react-router-dom'

const PublicHeader = () => {
  const { lang, setLang, t } = useLanguage()
  const navigate = useNavigate()

  const toggleLanguage = () => {
    setLang(lang === 'pl' ? 'en' : (lang === 'en' ? 'de' : 'pl'))
  }

  return (
    <AppBar position="sticky" color="inherit" elevation={0} sx={{ borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
      <Container maxWidth="xl">
        <Toolbar sx={{ height: 70 }}>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer' }} onClick={() => navigate('/') }>
            <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main', letterSpacing: '-0.02em' }}>
              YourModel.eu
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Button color="inherit" onClick={() => { window.location.href = '/opis-produktu/index.html' }}>
              {t('nav.product', 'Opis produktu')}
            </Button>
            <Button color="inherit" onClick={() => { window.location.href = '/inspiration/' }}>
              {t('nav.inspiration', 'Inspiracje')}
            </Button>
            <Button color="inherit" onClick={() => { window.location.href = '/opis-produktu/index.html#contact' }}>
              {t('nav.contact', 'Kontakt')}
            </Button>
            <IconButton onClick={toggleLanguage} size="small">
              <LanguageIcon />
            </IconButton>
            <Typography variant="caption" sx={{ ml: 0.5, opacity: 0.7 }}>{lang.toUpperCase()}</Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default PublicHeader
